import { Module } from 'vuex'
import { RootState } from '@/store/types'
import { DeadlinesState } from '@/store/deadlines/types'
import mutations from './mutations'
import actions from './actions'
import getters from './getters'

const Deadlines: Module<DeadlinesState, RootState> = {
  state: (): DeadlinesState => ({
    deadlines: [],
    pager: {
      current: 1,
      last: 1,
      totalLength: 0,
    },
    each: [],
  }),
  mutations,
  actions,
  getters,
}

export default Deadlines
